//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data(){
		return{
			ssgq:null,
		}
	},
	methods:{
		fh(){
			history.go(-1);
		},
		huoqu(){
			this.$store.dispatch('setgq',this.ssgq);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/search/sheader.vue